export default __webpack_public_path__ + "static/media/officalIlustrator.343363ac.svg";